// PRODUCTION — Formik auto-save helper
import React, { useEffect, useRef } from 'react'
import { useFormikContext } from 'formik'

export const AutoSave = <T extends object>({
  onSave,
  disabled = false,
}: {
  onSave: (v: T) => void
  disabled?: boolean
}) => {
  const { values } = useFormikContext<T>()
  const prevRef = useRef<T>(values)

  useEffect(() => {
    if (disabled) {
      prevRef.current = values

      return
    }

    if (prevRef.current !== values) {
      prevRef.current = values
      onSave(values)
    }
  }, [values, onSave, disabled])

  return null
}
